

export const createDebiValidation = (data) => {
  let temp = [];
  const numericRegex = /^\d{0,5}$/;
  const numericRegex1 = /^\d{5}$/;
  const alphanumeric1 = /^(?!.*(.).*\1)[a-zA-Z0-9!@#$%^&*()_+\-=[]{}|;':",.<>\/?]+/;
  for (let key in data) {
    if (key === "disCenter") {
      if (!data.disCenter) {
        temp.push("Distribution Center is a required field");
      }
    } else if (key === "store") {
      if (!data.store) {
        temp.push("Store is a required field");
      }
    } else if (key === "dealerNum") {
      
      if (!data.dealerNum) {
        temp.push("Dealer Number is a required field");
      } 
      else if (data.dealerNum && !numericRegex1.test(data.dealerNum)) {
        temp.push("Dealer Number must be five digits   Example:750 should be 00750.");
      }
    } else if (key === "bName") {
      if (!data.bName) {
        temp.push("Business Name is a required field");
      } else if (data.bName && (data.bName.length > 30)) {
        temp.push("Business Name is invalid.");
      }
    } else if (key === "tel") {
      if (!data.tel) {
        temp.push("Telephone is a required field");
      } else {
        var match = data[key].match(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/);
        if (!match) {
          temp.push("Telephone format is xxx-xxx-xxxx");
        }
      }
    } else if (key === "streetAddress") {
      if (!data.streetAddress) {
        temp.push("Street Address is a required field");
      } else if (data.streetAddress && (data.streetAddress.length > 30 )) {
        temp.push("Street Address should be of length 30.");
      } else if (data.streetAddress && alphanumeric1.test(data.streetAddress)){
        temp.push("Street Address is invalid.");
      }
    } else if (key === "installerEmail") {
      if (!data.installerEmail) {
        temp.push("Installer Email is a required field");
      } else {
        var mailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        var mailMAtch = mailFormat.test(data[key]);
        if (!mailMAtch) {
          temp.push("Installer Email must be a valid email address.");
        }
      }
    } else if (key === "city") {
      if (!data.city) {
        temp.push("City is a required field");
      } 
      else if (data.city && (data.city.length > 30 )) {
        temp.push("City Name should be of length 30.");
      } else if (data.city && alphanumeric1.test(data.city)){
        temp.push("City Name is invalid.");
      }
    } else if (key === "state") {
      if (!data.state) {
        temp.push("State is a required field");
      } 
       else if (data.state && (data.state.length > 30 )) {
        temp.push("State Name should be of length 30.");
      } else if (data.state && alphanumeric1.test(data.state)){
        temp.push("State Name is invalid.");
      }
    } else if (key === "zipcode") {
      if (!data.zipcode) {
        temp.push("Zip Code is a required field");
      } else if (data.zipcode && !numericRegex.test(data.zipcode)) {
        temp.push("Zip Code should be numeric and length should be 5.");
      }
    } else {
    }
  }

  return temp;
};

export const validateFields = (data, maintenanceList) => {
  let errors = {};

  maintenanceList.forEach((field) => {
    const fieldId = field.id;
    const fieldLabel = field.label;
    const filedValue = data[fieldId]
    const numericRegex = /^\d{1,3}$/;
    const zipRegex = /^[A-Za-z0-9]{5}$/;
    const alphanumeric = /^[A-Za-z0-9\s-]*$/;
    const alphabetOnly =/^[A-Za-z\s-]+$/;
    if ((data.id && fieldId === 'id' && !numericRegex.test(data.id)) ||
      (data.storeId && fieldId === 'storeId' && !numericRegex.test(data.storeId))) {
      errors[fieldId] = `${fieldLabel} field should be numeric and max length is 3.`
    } else if ((data.city && fieldId === 'city' && data.city?.length > 50) ||
   
      (data.storeAddress && fieldId === 'storeAddress' && data.storeAddress?.length > 50) ||
      (data.storeCity && fieldId === 'storeCity' && data.storeCity?.length > 30) ||
      (data.storeName && fieldId === 'storeName' && data.storeName?.length > 50) ||
      (data.storeState && fieldId === 'storeState' && data.storeState?.length > 50) ||
      (data.partNumber && fieldId === 'partNumber' && data.partNumber?.length > 30) ||
      (data.remark && fieldId === 'remark' && data.remark?.length > 255)){
      errors[fieldId] = `Maximum character limit exceed.`
    } else if ((data.city && fieldId === 'city' && !alphabetOnly.test(data.city)) ||
      (data.storeAddress && fieldId === 'storeAddress' && !alphanumeric.test(data.storeAddress)) ||
      (data.storeCity && fieldId === 'storeCity' && !alphabetOnly.test(data.storeCity)) ||
      (data.storeName && fieldId === 'storeName' && !alphanumeric.test(data.storeName)) ||
      (data.storeState && fieldId === 'storeState' && !alphabetOnly.test(data.storeState)) ||
      (data.partNumber && fieldId === 'partNumber' && !alphanumeric.test(data.partNumber)) ||
      (data.remark && fieldId === 'remark' && !alphanumeric.test(data.remark))) {
      errors[fieldId] = `${fieldLabel} is not valid.`
    } else if (data.storeZipcode && fieldId === 'storeZipcode' && !zipRegex.test(data.storeZipcode)) {
      errors[fieldId] = `${fieldLabel} is not valid.`
    } else if (!filedValue || filedValue.trim() === '') {
      errors[fieldId] = `${fieldLabel} field cannot be empty.`
    } 
  })

  return errors;
}

export const DebiValidations = (data) => {
  let temp = [];
  const numericRegex = /^\d{0,5}$/;
  const numericRegex1 = /^\d{5}$/;
  const alphanumeric1 = /^(?!.*(.).*\1)[a-zA-Z0-9!@#$%^&*()_+\-=[]{}|;':",.<>\/?]+/;
  for (let key in data) {
    if (key === "dealerNum") {
      
      if (!data.dealerNum) {
        temp.push("Dealer Number is a required field");
      } else if (data.dealerNum && !numericRegex1.test(data.dealerNum)) {
        temp.push("Dealer Number must be five digits   Example:750 should be 00750.");
      }
    } else
     if (key === "installerBusinessName") {
      if (!data.installerBusinessName) {
        temp.push("Business Name is a required field");
      } else if (data.installerBusinessName && (data.installerBusinessName.length > 30)) {
        temp.push("Business Name is invalid.");
      }
    } else if (key === "telephone") {
      if (!data.telephone) {
        temp.push("Telephone is a required field");
      } else {
        var match = data[key].match(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/);
        if (!match) {
          temp.push("Telephone formate is xxx-xxx-xxxx");
        }
      }
    } else if (key === "installerStreetAddress") {
      if (!data.installerStreetAddress) {
        temp.push("Street Address is a required field");
      } else if (data.installerStreetAddress && (data.installerStreetAddress.length > 30 )) {
        temp.push("Street Address should be of length 30.");
      } else if (data.installerStreetAddress && alphanumeric1.test(data.installerStreetAddress)){
        temp.push("Street Address is invalid.");
      }
    } else if (key === "installerEmail") {
      if (!data.installerEmail) {
        temp.push("Installer Email is a required field");
      } else {
        var mailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        var mailMAtch = mailFormat.test(data[key]);
        if (!mailMAtch) {
          temp.push("Installer Email must be a valid email address.");
        }
      }
    }  else if (key === "installerCity") {
      if (!data.installerCity) {
        temp.push("City is a required field");
      } 
      else if (data.installerCity && (data.installerCity.length > 30 )) {
        temp.push("City Name should be of length 30.");
      } else if (data.installerCity && alphanumeric1.test(data.installerCity)){
        temp.push("City Name is invalid.");
      }
    } else if (key === "installerState") {
      if (!data.installerState) {
        temp.push("State is a required field");
      } 
       else if (data.installerState && (data.installerState.length > 30 )) {
        temp.push("State Name should be of length 30.");
      } else if (data.installerState && alphanumeric1.test(data.installerState)){
        temp.push("State Name is invalid.");
      }
    } else if (key === "zipCode") {
      if (!data.zipCode) {
        temp.push("Zip Code is a required field");
      } else if (data.zipCode && !numericRegex.test(data.zipCode)) {
        temp.push("Zip Code should be numeric and length should be 5.");
      }
    } else {
    }
  }
  return temp;
};